<template>
  <div>
    <ul class="contentsList shopList">
      <li v-for="shop in shopList">
        <div class="contentsWrap">
          <a :href="shop.url" class="eyecatch">
            <img v-if="shop.full_image_path" :data-src="shop.full_image_path" :alt="shop.name" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="shop.name">
          </a>
          <div class="detail">
            <div class="location">
              <ol>
                <li>{{ shop.areaInfo.island_name }}</li>
                <li>{{ shop.areaInfo.area_name }}</li>
              </ol>
            </div>
            <div class="name">
              <a :href="shop.url">{{ shop.display_name }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ shop.category.name_public }}</div>
              <!-- <div class="icon star">{{ shop.star_count }}</div> -->
              <div class="icon heart">{{ shop.liked }}</div>
            </div>
          </div>
          <div class="favoriteIcon" :class="{ 'notFavorite': !shop.likeFlag }" @click.stop="changeLike(shop, 1)"></div>
        </div>
      </li>
    </ul>
    <ul class="contentsList articleList">
      <li v-for="article in articleList">
        <div class="contentsWrap">
          <a :href="article.url" class="eyecatch">
            <img v-if="article.eyecatch_img_path" :data-src="article.eyecatch_img_path" :alt="article.title" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="article.title">
          </a>
          <div class="detail">
            <div class="name">
              <a :href="article.url">{{ article.title }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ article.category.name_public }}</div>
              <div class="icon heart">{{ article.liked }}</div>
            </div>
          </div>
          <div class="favoriteIcon" :class="{ 'notFavorite': !article.likeFlag }" @click.stop="changeLike(article, 2)"></div>
        </div>
      </li>
    </ul>
    <ul class="contentsList movieList">
      <li v-for="movie in movieList">
        <div class="contentsWrap">
          <a :href="movie.url" class="eyecatch">
            <img v-if="movie.eyecatch_img_path" :data-src="movie.eyecatch_img_path" :alt="movie.title" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="movie.title">
          </a>
          <div class="detail">
            <div class="name">
              <a :href="movie.url">{{ movie.title }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ movie.category.name_public }}</div>
              <div class="icon heart">{{ movie.liked }}</div>
            </div>
          </div>
          <div class="favoriteIcon" :class="{ 'notFavorite': !movie.likeFlag }" @click.stop="changeLike(movie, 3)"></div>
        </div>
      </li>
    </ul>
    <ul class="contentsList giftList">
      <li v-for="gift in giftList">
        <div class="contentsWrap">
          <a :href="gift.url" class="eyecatch">
            <img v-if="gift.eyecatch_img_path" :data-src="gift.eyecatch_img_path" :alt="gift.title" class="lazyload">
            <img v-else src="/img/aloco_img_1.svg" :alt="gift.title">
          </a>
          <div class="detail">
            <div class="name">
              <a :href="gift.url">{{ gift.title }}</a>
            </div>
            <div class="categories">
              <div class="category">{{ gift.category.name_public }}</div>
              <div class="icon heart">{{ gift.liked }}</div>
            </div>
          </div>
          <div class="favoriteIcon" :class="{ 'notFavorite': !gift.likeFlag }" @click.stop="changeLike(gift, 4)"></div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
      return {
        shopList: [],
        articleList: [],
        movieList: [],
        giftList: [],
        params: {
          shop: [],
          article: [],
          movie: [],
          gift: []
        }
      }
  },
  mounted() {
    this.getHistory()
  },
  methods: {
    async getHistory() {
      let shopHistory = localStorage.getItem('shopHistory')
      let articleHistory = localStorage.getItem('articleHistory')
      let movieHistory = localStorage.getItem('movieHistory')
      let giftHistory = localStorage.getItem('giftHistory')
      if (shopHistory) {
        shopHistory = JSON.parse(shopHistory)
        this.params.shop = shopHistory;
      }
      if (articleHistory) {
        articleHistory = JSON.parse(articleHistory)
        this.params.article = articleHistory;
      }
      if (movieHistory) {
        movieHistory = JSON.parse(movieHistory)
        this.params.movie = movieHistory;
      }
      if (giftHistory) {
        giftHistory = JSON.parse(giftHistory)
        this.params.gift = giftHistory;
      }
      this.getInfo();
    },
    async getInfo() {
      // 閲覧履歴情報取得API
      await axios.post('/api/users/history/get', this.params).then(res => {
        if (res.data.success) {
          this.shopList = res.data.shop.sort((a, b) => {
            return this.params.shop.indexOf(a.id) - this.params.shop.indexOf(b.id);
          });
          this.articleList = res.data.article.sort((a, b) => {
            return this.params.article.indexOf(a.id) - this.params.article.indexOf(b.id);
          });
          this.movieList = res.data.movie.sort((a, b) => {
            return this.params.movie.indexOf(a.id) - this.params.movie.indexOf(b.id);
          });
          this.giftList = res.data.gift.sort((a, b) => {
            return this.params.gift.indexOf(a.id) - this.params.gift.indexOf(b.id);
          });
        } else {
          this.errors = res.data.errors
        }
      }).catch(e => {
        console.log('Error', e)
      });
    },
    changeLike(content, contentType) {
      let url;
      let type;
      if (!content.likeFlag) {
        url = '/api/users/like/add'
        type = 'add'
      } else {
        url = '/api/users/like/delete'
        type = 'delete'
      }
      this.$axios.post(url, {
        content_id: content.id,
        content_type: contentType
      })
        .then((res) => {
          if (res.status === 200) {
            if (type === 'add') {
              content.likeFlag = true
              content.totalLike += 1
            } else {
              content.likeFlag = false
              content.totalLike -= 1
            }
          }
        })
        .catch((e) => {
          console.log('Error', e)
        })
    }
  }
}
</script>
